import { INavData } from "@coreui/angular";

export const defaultNavItems: INavData[] = [
	{
		name: "Dashboard",
		url: "/dashboard",
		icon: "pi pi-home",
	},
	{
		title: true,
		name: "Accesos Rapidos",
	},
	{
		name: "Banners",
		url: "/admin/svs/banner",
		icon: "pi pi-video",
	},
	{
		name: "Campañas",
		url: "/client/config/design-reels",
		icon: "pi pi-video",
	},
	{
		name: "Layouts",
		url: "/admin/svs/layouts",
		icon: "pi pi-images",
	},
	{
		title: true,
		name: "General",
	},
	{
		name: "Configuración",
		url: "/admin/admin",
		icon: "pi pi-cog",
		children: [
			{
				name: "Usuario",
				url: "/admin/svs/usuarios",
				icon: "pi pi-user",
			},
			{
				name: "Roles",
				url: "/client/config/roles",
				icon: "pi pi-id-card",
			},
			{
				name: "Permisos",
				url: "/client/config/permisos",
				icon: "pi pi-lock",
			},
			// {
			// 	name: "Campañas (BETA)",
			// 	url: "/client/config/reels",
			// 	icon: "pi pi-lock",
			// },
		],
	},
	{
		name: "Unidades",
		url: "/admin/admin",
		icon: "pi pi-car",
		children: [
			{
				name: "Grupos de Unidades",
				url: "/admin/svs/groups",
				icon: "pi pi-sitemap",
			},
		],
	},
	{
		name: "Media",
		url: "/admin/admin",
		icon: "pi pi-folder",
		children: [
			{
				name: "Layouts",
				url: "/admin/svs/layouts",
				icon: "pi pi-images",
			},
			// {
			// 	name: "Diseñador layouts",
			// 	url: "/admin/svs/layouts-designer",
			// 	icon: "pi pi-images",
			// },
			{
				name: "Categorias",
				url: "/client/config/categorias",
				icon: "pi pi-tags",
			},
			{
				name: "Categorias de Campañas",
				url: "/admin/svs/reel-categories",
				icon: "pi pi-tags",
			},
		],
	},
	{
		name: "Router",
		url: "/admin/admin",
		icon: "pi pi-globe",
		children: [
			{
				name: "boxes",
				url: "/admin/admin/boxes",
				icon: "pi pi-desktop",
			},
		],
	},
	{
		name: "Herramientas",
		url: "/admin/admin",
		icon: "pi pi-cog",
		children: [
			{
				name: "Probabilidad",
				url: "/admin/svs/herramientas",
				icon: "pi pi-tags",
			},
		],
	},
	{
		name: "Clientes",
		url: "/admin/client",
		icon: "pi pi-cog",
		children: [
			{
				name: "Partners",
				url: "/client/config/clientes",
				icon: "pi pi-briefcase",
			},
			{
				name: "Compañías",
				url: "/admin/svs/company-client",
				icon: "pi pi-briefcase",
			},
			{
				name: "Cliente",
				url: "/admin/svs/media-client",
				icon: "pi pi-briefcase",
			},
			
		],
	},
];

export const navGroup = {
	name: "Grupos de Unidades",
	url: "/admin/svs/groups",
	icon: "pi pi-sitemap",
};

export const navReels = {
	name: "Campañas",
	url: "/client/config/design-reels",
	icon: "pi pi-video",
};

export const navUnits = {
	name: "Unidades",
	url: "/admin/svs/units",
	icon: "pi pi-mobile",
};

export const navMedia = {
	name: "Media",
	url: "/admin/svs/media",
	icon: "pi pi-images",
};

export const navItemsUserRole: INavData[] = [
	// {
	// 	name: 'Dashboard',
	// 	url: '/dashboard',
	// 	icon: 'pi pi-home',
	// },
	navMedia,
	navReels,
	navUnits,
	navGroup,
];
